module.exports = __webpack_public_path__ + "static/media/bg.c29fccf4.png";